import { z } from 'zod';

export const TSDGenerateResponseDataSchema = z.object({
  tsdId: z.string().min(1, { message: 'Required' }),
  responseType: z.string().min(1, { message: 'Required' }),
});
export type TSDGenerateResponseData = z.infer<typeof TSDGenerateResponseDataSchema>;
